// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"36":"34260fe0","61":"a1b75193","89":"6c06f50c","100":"2b5321fd","161":"c76c16e3","557":"df9fd07d","796":"ad260861","814":"85afa177"}[chunkId] + ".css";
};